








import { faPrint } from '@fortawesome/free-solid-svg-icons'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  data: () => ({
    icons: {
      print: faPrint
    }
  })
})
